<template>
  <ul class="nav nav-tabs nav-tabs-solid bg-transparent border-bottom mb-3">
    <li class="nav-item">
      <router-link
        v-bind:class="{
          active: currentPath.includes('general-settings/security-settings'),
        }"
        class="nav-link"
        to="/general-settings/profile-settings"
        ><i class="ti ti-settings me-2"></i>General Settings</router-link
      >
    </li>

    <li class="nav-item">
      <router-link
        v-bind:class="{
          active:
            currentPath.includes('system-settings/email-settings') ||
            currentPath.includes('system-settings/email-template'),
        }"
        class="nav-link"
        to="/system-settings/email-settings"
        ><i class="ti ti-server-cog me-2"></i>System Settings</router-link
      >
    </li>
   
    <li class="nav-item">
      <router-link
        v-bind:class="{
          active:
            currentPath.includes('others-settings/custom-js') ||
            currentPath.includes('others-settings/cronjob') ||
            currentPath.includes('others-settings/storage-settings') ||
            currentPath.includes('others-settings/ban-ip-address') ||
            currentPath.includes('others-settings/backup') ||
            currentPath.includes('others-settings/clear-cache'),
        }"
        class="nav-link"
        to="/others-settings/cronjob"
        ><i class="ti ti-settings-2 me-2"></i>Other Settings</router-link
      >
    </li>
  </ul>
</template>
<script>
export default {
  data() {
    return {
      currentPath: this.$route.path,
    };
  },
};
</script>
